export default function Logo({ height }) {
    return (
        <img className="logo" src="/images/logo/logo.png" alt="SWAN charity logo" style={{ height }} />
    )
}